import { grannyFixit } from './grannyFixit';

// A controlled URL resolves a module; this registry is never rendered as a student menu.
const lessons = Object.freeze({ [grannyFixit.lesson_id]: Object.freeze({ [grannyFixit.lesson_version]: grannyFixit }) });
export function getLesson(id, version = 1) { return lessons[id]?.[version] || null; }
export function resolveRoute(pathname, search = '') {
  if (pathname === '/' || pathname === '/legacy/reading-study-mvp') return { kind: 'legacy' };
  const match = /^\/lesson\/([a-z0-9-]+)\/?$/.exec(pathname);
  const parameters = new URLSearchParams(search);
  const version = parameters.get('version') || '1';
  const lesson = match && /^[1-9][0-9]*$/.test(version) && getLesson(match[1], Number(version));
  if (!lesson) return { kind: 'unassigned' };
  const requestedMode = parameters.get('mode') || 'demo';
  if (!['demo', 'research'].includes(requestedMode)) return { kind: 'unassigned' };
  if (requestedMode === 'research' && !lesson.research_ready) return { kind: 'not-ready', lesson };
  return { kind: 'lesson', lesson, mode: requestedMode };
}
